var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-counter"},[_vm._t("default"),_c('span',{staticClass:"counter",style:(_vm.stylesCounter)},[_vm._v(_vm._s(_vm.text ? _vm.text.length : 0)+"/"+_vm._s(_vm.maxLength))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }